import {connect} from 'react-redux'

import {AccommodationsOverview} from './accommodationsoverview.component'
import legUtil from '../util/leg.util'


const mapStateToProps = (state) => {
    let leg = legUtil.getActiveLeg(state)

    return {
        leg: leg,
        hasAccommodation: !leg.get('accommodations').isEmpty(),
        lunaTrip: state.get('lunaTrip')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

const AccommodationsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AccommodationsOverview)

export default AccommodationsContainer
